import { TestImage } from "@assets/constant/index.constant";
import { Button } from "@components/ui/button";
import { endpoint } from "@services/api.services";
import { GeneralCard, TableCard } from "@ui/internal/components/card";
import FilterPopover from "@ui/internal/components/filter-popover";
import { formatDate, showToast } from "@utils/helper/index.helper";
import { usePathname } from "@utils/hook/index.hook";
import { METHODS, QueryMetaData } from "@utils/interface/index.interface";
import { BlogData } from "@utils/interface/journey.interface";
import { useListData, usePostData } from "@utils/query/index.query";
import { useMetaStore } from "@utils/states/index.state";
import React, { useEffect } from "react";
import { NavLink, useSearchParams } from "react-router";
import { ColumnList } from "./column/index.column";
type Props = {};
interface SelectionProps {
  deleted: number;
  draft: number;
  published: number;
  scheduled: number;
}
const BlogsC: React.FC<Props> = ({}) => {
  const pathname = usePathname();
  const { search, date } = useMetaStore();
  const [searchParams, setSearchParams] = useSearchParams();

  let { data, refetch, isPending, error } = useListData<
    QueryMetaData<BlogData, SelectionProps>
  >({
    endpoint: endpoint["blog"],
    key: `${pathname}-listing`,
    params: {
      page: searchParams.get("tpage") || 1,
      size: searchParams.get("per") || 10,
      search,
      created_date__gte: date.from ? formatDate(date.from) : "",
      created_date__lte: date.to ? formatDate(date.to) : "",
      ordering: searchParams.get("ordering") || "-created_at",
      category: searchParams.get("blog-category-linked") || "",
      status:
        searchParams.get("data-category")?.toLocaleLowerCase()?.split("-")[0] ||
        "published",
    },
  });
  // rollback page
  useEffect(() => {
    if (error?.status === 404 && error?.data?.detail === "Invalid page.") {
      searchParams.set("tpage", "1");
      setSearchParams(searchParams);
    }
  }, [error]);

  // useEffect(() => {
  //   setSearchParams({ ordering: "-created_at" });
  // }, []);

  const { mutate } = usePostData();

  const moveToBin = (id: string | number, state: boolean) => {
    mutate(
      {
        endpoint: endpoint["blog"],

        data: {
          is_deleted: state,
          status: "deleted",
          id,
        },
        method: METHODS.PATCH,
      },
      {
        onSuccess: () => {
          let intermediatedata = data?.data?.results.filter(
            (item) => item.slug !== id,
          );

          if (data && data.data.results && intermediatedata) {
            console.log("Data", data.data.results);
            data.data.results = intermediatedata;
          }
          refetch();
          showToast({
            title: "Success",
            description: "Blog has been moved to Trash successfully",
            type: "success",
          });
        },
        onError: (data) => {
          showToast({
            title: "Error",
            description: "Blog Failed to move to Trash",
            type: "error",
          });
        },
      },
    );
  };
  const moveToDraft = (id: string | number, state: boolean) => {
    mutate(
      {
        endpoint: endpoint["blog"],

        data: {
          is_deleted: false,
          status: "draft",
          id,
        },
        method: METHODS.PATCH,
      },
      {
        onSuccess: () => {
          let intermediatedata = data?.data?.results.filter(
            (item) => item.slug !== id,
          );
          refetch();
          console.log(intermediatedata, "intermediatedata");
          if (data && data.data && intermediatedata) {
            data.data.results = intermediatedata;
          }
          showToast({
            title: "Success",
            description: "Blog has been moved to Draft successfully",
            type: "success",
          });
        },
        onError: (data) => {
          console.log(data);
        },
      },
    );
  };

  const columns = ColumnList({ refetch, moveToBin, moveToDraft });
  return (
    <>
      <TableCard
        bulkActions
        table_content={{
          mode: "default",
          type: pathname,
        }}
        inject_ui_table_actions={
          <>
            <Button variant={"defaultoutline"}>
              <NavLink to="/blogsC-category">Manage Categories</NavLink>
            </Button>
            <FilterPopover
              filters={[
                {
                  label: "Category",
                  endpointValue: "blog-category-linked",
                  format: { key: "name", value: "id" },
                },
              ]}
              title="Filter"
              triggerText="Filter"
            />
          </>
        }
        isPending={isPending}
        showOrientationSecond
        sortableFilter={{
          search,
          created_date__gte: date.from ? formatDate(date.from) : "",
          created_date__lte: date.to ? formatDate(date.to) : "",
          ordering: searchParams.get("ordering") || "order",
          category: searchParams.get("blog-category-linked") || "",
          status:
            // searchParams
            //   .get("data-category")
            //   ?.toLocaleLowerCase()
            //   ?.split("-")[0] === "published"
            //   ? ""
            //   :
            searchParams
              .get("data-category")
              ?.toLocaleLowerCase()
              ?.split("-")[0] || "",
        }}
        tableHeaderData={[
          {
            id: 1,
            name: "Published",
            count: data?.data.sections?.published || 0,
          },
          {
            id: 2,
            name: "Scheduled",
            count: data?.data.sections?.scheduled || 0,
          },
          { id: 3, name: "Draft", count: data?.data.sections?.draft || 0 },
          { id: 4, name: "Deleted", count: data?.data.sections?.deleted || 0 },
        ]}
        grid={
          <GeneralCard
            isChecked={false}
            showCheck
            type={"blog"}
            content={{
              username: "Yunika Shakya",
              userdesignation: "UI/UX Designer",
              userimage: TestImage || "",
              description:
                "Digital Marketing Mentorgital Marketing Mentorgital Marketing Mentor",
            }}
            onDelete={() => {}}
            onEdit={() => {}}
          />
        }
        columns={columns}
        endpoint={endpoint["blog"]}
        refetch={refetch}
        rows={data?.data?.results ?? []}
        count={data?.data?.count ?? 10}
      />
    </>
  );
};

export default BlogsC;
